<template>
<div class="page page_baocuo page_map page_publish">
    <div class="filed">
        <div class="filed_title">标题</div>
        <div class="filed_nr">
            <van-field v-model="title" :border="false" placeholder="请您输入...." />
        </div>
    </div>
    <div class="filed">
        <div class="filed_title">发布内容</div>
        <div class="filed_nr">
            <van-field v-model="content" :border="false" type="textarea" placeholder="你的今天，明天的历史，分享此刻....." />
        </div>
    </div>
    <div class="filed">
        <div class="filed_title">上传图片</div>
        <div class="filed_nr">
            <div class="upload-images">
                <div class="img-box" v-for="(item, index) in imglist" :key="index">
                    <div class="icon-po">
                        <van-image :show-error="false" :show-loading="false" class="image" fit="contain" :src="imageUrl+item" />
                    </div>
                    <div class="del" @click="imgDel(index)"></div>
                </div>
                <van-uploader :after-read="onRead" accept multiple class="icon-add" ref="addPhone">
                    <div class="addPhone"></div>
                </van-uploader>
            </div>
        </div>
    </div>
	<!-- 上传音频 -->
	<!-- <div class="filed">
        <div class="filed_title">上传音频</div>
        <div class="filed_nr">
            <div class="upload-images">
                <div class="img-box" v-for="(item, index) in audioList" :key="index">
                    <div class="del" @click="audioDel(index)"></div>
                </div>
                <van-uploader :after-read="onReadVideo" accept="audio/*" max-count="1" class="icon-add" ref="addPhone">
                    <div class="addPhone"></div>
                </van-uploader>
            </div>
			<input type="file" id="videoInput" accept="audio/*" @change="upVideo">
        </div>
    </div> -->
	<!-- <div class="filed">
        <div class="filed_title">上传音频</div>
        <div class="filed_nr">
            <div class="upload-images">
                <van-uploader :after-read="onReadVideo" v-model="audioList" accept="audio/*" max-count="1" class="icon-add">
                    <div class="addPhone"></div>
                </van-uploader>
            </div>
        </div>
    </div> -->
    <!-- 事件时间 -->
    <div class="filed" @click="show_time = true">
        <div class="filed_title">事件时间</div>
        <van-field v-model="time" placeholder="可选择事件时间" readonly />
    </div>
    <!-- 所在位置 -->
    <div class="location" @click="toSelectPoi">
        <van-field v-model="landmark" placeholder="所在位置" readonly>
            <van-icon slot="left-icon" name="location-o" class="location_icon" />
            <van-icon slot="right-icon" name="arrow" />
        </van-field>
    </div>
    <div class="actions">
        <div class="bottom_action" @click="tijiaoFun">{{ tijiao_loading ?'提交中':'发布'}}</div>
    </div>
    <!-- 选择时间 -->
    <van-popup v-model="show_time" position="bottom">
        <van-datetime-picker v-model="currentDate" type="datetime" @confirm="confirmTime" @cancel="show_time = false" :max-date="maxDate" />
    </van-popup>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            token: null,
            title: '', // 标题
            content: '', // 内容
            imglist: [],
            drift_id: this.$route.query.drift_id,
            tijiao_loading: false,
            time: null, // 事件时间
            show_time: false,
            currentDate: new Date(),
            maxDate: new Date(),
            selectPoi: null, //已选POI
			landmark: null, // 地标名称
			audio_url: null, // 音频url
			upload_loading: false // 上传loading
        };
    },
    created: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '书写记忆让爱漂流'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                } else {
                    this.token = ''
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            // 获取列表
            this.token = this.$store.getters.token
        }

	},
	watch: {
		'$route': function(val,old){
			console.log('触发路由监测')
			// 获取所在位置
			if (localStorage.getItem('selectPoi')) {
				var obj = localStorage.getItem('selectPoi')
				this.selectPoi = JSON.parse(obj)
				if(this.selectPoi.type != 0){
					if(this.selectPoi.type == 1){
						this.landmark = this.selectPoi.city
					}else if(this.selectPoi.type == 2){
						this.landmark = this.selectPoi.landmark
					}
				}else{
					this.landmark = null
				}
			}
		}
	},
	beforeRouteLeave(to,from,next){
		console.log('beforeRouteLeave')
		// 动态设置路由缓存
		if(to.name == 'location-list'){
			from.meta.keepAlive = true
			next()
		}else{
			from.meta.keepAlive = false
			next()
		}
	},
    mounted: function () {
        if (this.drift_id != null) {
            // 获取详情,初始化详情信息
            this.getData()
		}
    },
    methods: {
        // 上传图片
        onRead: function (file) {
            // console.log("file");
            // console.log(file);
            if ($.isArray(file)) {
                for (var i in file) {
                    this.$api.index.uploadImage({
                        imgFile: file[i].content
                    }).then(res => {
                        if (res.code == 200) {
                            this.imglist.push(res.result.url);
                        }
                    });
                }
            } else {
                this.$api.index.uploadImage({
                    imgFile: file.content
                }).then(res => {
                    if (res.code == 200) {
                        this.imglist.push(res.result.url);
                    }
                });
            }
        },
        // 删除图片
        imgDel(index) {
            this.imglist.splice(index, 1);
        },
        // 提交
        tijiaoFun() {
			if(this.upload_loading){
				this.$toast('音频正在上传中,请稍等')
				return
			}
            if (this.tijiao_loading) {
				// console.log('提交多次')
                return
            }
            if (!this.title && !this.content && this.imglist.length == 0) {
                this.$toast('您尚未填写任何信息,请填写,再发布')
                return
            }
            // if(!this.title){
            // 	this.$toast('请填写标题')
            // 	return
            // }
            // if(!this.content){
            // 	this.$toast('请填写内容')
            // 	return
            // }
            // if(this.imglist.length == 0){
            // 	this.$toast('请上传图片')
            // 	return
            // }
            // 标题、内容、图片填写一个方可发布
            var params = {
                token: this.token
            }
            if (this.title) {
                params.title = this.title
            }
            if (this.content) {
                params.content = this.content
            }
            if (this.imglist.length != 0) {
                var strImages = this.imglist.join()
                params.images = strImages
            }
            if (this.drift_id != null) {
                params.drift_id = this.drift_id
            }
            if (this.time != null && this.time != undefined ) {
                params.push_at = this.time
			}
			// 位置 landmark 地标 、address 地址、area_name区、city_name 城市、province_name 省、lng 经度、lat 纬度
			if(this.selectPoi && this.selectPoi.type != 0){
				params.lng = this.selectPoi.lng
				params.lat = this.selectPoi.lat
				params.province_name = this.selectPoi.province
				params.city_name = this.selectPoi.city
				params.area_name = this.selectPoi.district
				params.address = this.selectPoi.address
				if(this.selectPoi.type == 1){
					params.landmark = this.selectPoi.city
				}else if(this.selectPoi.type == 2){
					params.landmark = this.selectPoi.landmark
				}
			}
			// 音频
			if(this.audio_url){
				params.audio_url = this.audio_url
			}
            console.log(params)
            this.tijiao_loading = true
            if (this.tijiao_loading) {
                if (this.drift_id == null) {
                    this.$api.history.lovedriftCreate(params).then(res => {
                        if (res.code == 200) {
                            this.$toast('发布成功,请等待审核')
                            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                                //返回上级页面
                                var params = {
                                    'data': {}
                                }
                                this.$bridge.callhandler('sdjy://public/back', params, (data) => {
									
                                })
                            } else {
                                this.$router.back()
                            }
                            this.tijiao_loading = false
                        }else{
							this.tijiao_loading = false
						}
                    })
                } else {
                    this.$api.history.lovedriftEdit(params).then(res => {
                        if (res.code == 200) {
                            this.$toast('修改成功,请等待审核')
                            this.$router.back()
                            this.tijiao_loading = false
                        }else{
							this.tijiao_loading = false
						}
                    })
                }
            }

        },
        // 获取详情信息
        getData() {
            var params = {
                token: this.token,
                drift_id: this.drift_id,
                page: 1,
                size: 10
            }
            this.$api.history.lovedriftInfo(params).then(res => {
                if (res.code == 200) {
                    var info = res.result
                    if (info.images) {
                        info.imagesArr = info.images.split(',')
                    }
                    this.title = info.title
                    this.content = info.content
                    this.imglist = info.imagesArr
                }
            })
        },
        // 确认时间
        confirmTime(e) {
            console.log(e, new Date(e))
            var that = this
            var time = {
                'year': e.getFullYear(),
                'month': (e.getMonth() + 1).toString().length == 1 ? '0' + (e.getMonth() + 1) : e.getMonth() + 1,
                'day': e.getDate().toString().length == 1 ? '0' + e.getDate() : e.getDate(),
                'hour': e.getHours().toString().length == 1 ? '0' + e.getHours() : e.getHours(),
                'minute': e.getMinutes().toString().length == 1 ? '0' + e.getMinutes() : e.getMinutes(),
                'second': e.getSeconds().toString().length == 1 ? '0' + e.getSeconds() : e.getSeconds()
            }
            that.time = time.year + '-' + time.month + '-' + time.day + ' ' + time.hour + ':' + time.minute + ':' + time.second
            that.show_time = false
		},
		// 去选择poi
		toSelectPoi(){
			var that = this
			that.$router.push({
				path: '/location/list'
			})
		},
		// 上传音频
		upVideo(event){
			var that = this
			console.log('触发了====')
			var input = document.getElementById('videoInput')
			var videoFile = input.files[0]
			console.log('文件====',videoFile)
			var data = new FormData();
			data.append("imgFile", videoFile);
			console.log('FormData=====',data)
			this.upload_loading = true
			$.ajax({
                type: 'POST',
                url: '/common/upload/file', // 上传图片
                data: data,
                processData: false, // 告诉jquery要传输data对象
                contentType: false,   //  告诉jquery不需要增加请求头对于contentType的设置
                success: function (res) {
					console.log('上传了吗',res)
					if(res.code == 200){
						that.$toast(res.msg)
						that.audio_url = res.result.url
						that.upload_loading = false
					}
                }
            })
		}
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.page .upload-images {
    margin-top: .4rem;
}

/deep/.van-cell .van-field__control {
    color: rgba(0, 0, 0, 0.54);
    padding-left: 0;
}

/deep/.van-field--min-height .van-field__control {
    min-height: 4rem !important;
}
</style>
